import * as React from "react";
import { SecondaryButton } from "@graffer-inc/console-design-kit";

type ProceduresSearchWindowProps = {
  searchName: string;
  setSearchName: (name: string) => void;
  searchProcedures: (name: string) => void;
};

export const ProceduresSearchWindow: React.FC<ProceduresSearchWindowProps> = ({
  searchName,
  setSearchName,
  searchProcedures,
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        searchProcedures(searchName);
      }}
      className="field has-addons"
      style={{
        marginBottom: "0",
      }}
    >
      <p className="control has-icons-left has-icons-right">
        <input
          className="input"
          placeholder="手続き名で検索"
          value={searchName || ""}
          onChange={(e) => setSearchName(e.target.value)}
          style={{
            fontSize: "14px",
          }}
        />
        <span className="icon is-small is-left">
          <i className="fas fa-search" />
        </span>
        <span
          className="icon is-small is-right"
          role="button"
          onClick={() => {
            setSearchName("");
            searchProcedures("");
          }}
          style={{ pointerEvents: "initial", cursor: "pointer" }}
        >
          <i className="fas fa-times" />
        </span>
      </p>
      <p className="control">
        <SecondaryButton text="検索" type="submit" />
      </p>
    </form>
  );
};
